import React from 'react'
import PropTypes from 'prop-types'
import { createComponent } from 'react-fela'
import { __TicketPill } from './__style'

const Ticket = createComponent(__TicketPill, 'button', ['onClick'])

const TicketPill = ({ info, status, handleClick, clicked }) => {
	return (
		<Ticket onClick={handleClick} clicked={clicked} status={status}>
			{info}
		</Ticket>
	)
}
TicketPill.defaultProps = {
	info: 'Ticket 1',
	status: true,
	handleClick: () => {},
	clicked: false,
}

TicketPill.propTypes = {
	info: PropTypes.string,
	status: PropTypes.bool,
	handleClick: PropTypes.func,
	clicked: PropTypes.bool,
}

export default TicketPill
